// extracted by mini-css-extract-plugin
export default {"agreement-container":"styles_agreement-container__POzqW","agreement-checkbox":"styles_agreement-checkbox__Jku6p"};